<div class="form-floating-renderer py-1">
  <div class="d-flex gap-2" *ngIf="params?.isOnlyNumbersEnabled; else noDirective">
  <span  class="{{!params?.data?.isDisable && params?.data?.isNewRow? 'visible' : 'invisible'}} text-primary-color font-13 mt_05">Split</span>
  <input 
  onlyNumbers
  [type]="'text'"
  class="form-control inputWidth_01"
  id="floatingInput"
  autocomplete="off"
  [(ngModel)]="params.value"
  (ngModelChange)="inputValueEmit($event)"
  placeholder="''"
   />
</div>

<ng-template #noDirective>
  <input 
  [type]="'text'"
  class="form-control inputWidth_02"
  id="floatingInput"
  autocomplete="off"
  [(ngModel)]="params.value"
  (ngModelChange)="inputValueEmit($event)"
  placeholder="''"
/>
</ng-template>
</div>
    